'use strict'

const _ = require('lodash');

const bs = {};

bs.bColumn = function(def_xs = 12, def_sm = def_xs, def_md = def_sm, def_lg = def_md){

  return function(xs = def_xs, sm = def_sm, md = def_md, lg = def_lg){
    return shortify('',xs,sm,md,lg);
  }

};

bs.bOffset = function(def_xs = 1, def_sm = def_xs, def_md = def_sm, def_lg = def_md){

  return function(xs = def_xs, sm = def_sm, md = def_md, lg = def_lg){
    return shortify('offset-',xs,sm,md,lg);
  }

};


bs.bPush = function(def_xs = 1, def_sm = def_xs, def_md = def_sm, def_lg = def_md){

  return function(xs = def_xs, sm = def_sm, md = def_md, lg = def_lg){
    return shortify('push-',xs,sm,md,lg);
  }

};

bs.bPull = function(def_xs = 1, def_sm = def_xs, def_md = def_sm, def_lg = def_md){

  return function(xs = def_xs, sm = def_sm, md = def_md, lg = def_lg){
    return shortify('pull-',xs,sm,md,lg);
  }

};

module.exports = bs;


function shortify(prefix, xs, sm, md, lg) {

  let bClass = '';
  var xs = xs; sm = sm; md = md; lg = lg;

  //check if it is a plain object with xs,sm,md,lg keys only
  if(_.isPlainObject(xs)) {
    let obj = xs;
    let arr = _.keys(obj);
    let check_arr = _.difference(arr, ['xs','sm','md','lg']);

    if(check_arr.length !== 0){
      throw new Error("BSshortify: incorrect keys " + check_arr + ", should be each of " + arr);
    }

    var { xs, sm, md, lg } = xs;

  }

  //check if the first argument is a space separated list of values ie. ("12 12 6 6")
  if (_.isString(xs)){
    let checkIfList = xs.split(" ") || false;

    if (checkIfList.length === 4) {
      xs = checkIfList;
    } else if (checkIfList && checkIfList.length !== 1){
      throw new Error("BSshortify: incorrect number of space-separated arguments or a space that needs to be deleted");
    }
  }

  //turn the arguments into numbers in case they were passed in as strings i.e. ("12","12","6","6")
  //so that they can be cought by isNumber option, later, downstream

  if (_.isString(xs) || _.isString(sm) || _.isString(md) || _.isString(lg)) {
    xs = parseInt(xs);
    sm = parseInt(sm);
    md = parseInt(md);
    lg = parseInt(lg);
  }

  //destructure the array argument into variables xs,sm,md,lg that are numbers.
  if ( _.isArray(xs)) {

    xs = xs.map(v => parseInt(v));

    var [xs, sm, md, lg] = xs;
  }

  //by now there should be 4 aruments (xs,sm,md,lg) that are numbers
  if (_.isNumber(xs) || _.isNumber(sm) || _.isNumber(md) || _.isNumber(lg)) {

    let suffix_xs = prefix + xs;
    let suffix_sm = prefix + sm;
    let suffix_md = prefix + md;
    let suffix_lg = prefix + lg;

    bClass += xs ? ` col-xs-${suffix_xs}` : ``;
    bClass += sm ? ` col-sm-${suffix_sm}` : ``;
    bClass += md ? ` col-md-${suffix_md}` : ``;
    bClass += lg ? ` col-lg-${suffix_lg}` : ``;

    bClass = bClass.trim(); //remove spaces at the begining and at the end


  } else {
    throw new Error("BSshortify: there seems to be something wrong with the arguments");
  }


  return bClass;
};
